module.exports = {"svg":{"$":{"width":"128","height":"128","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M0 54.857h54.796v18.286H36.531V128H18.265V73.143H0V54.857zm127.857-36.571H91.935V128H72.456V18.286H36.534V0h91.326l-.003 18.286z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/size.svg
// module id = 402
// module chunks = 0